import React from 'react'
import { Link } from 'gatsby'
import styled, { css } from 'styled-components'
import withLocation from '../common/with-location'
import { useScrollTop } from '../hooks'
import FoldIcon from '../images/fold.svg'
import ExpandIcon from '../images/expand.svg'

const fontSize = new Map([
  [1, '14px'],
  [2, '13px'],
  [3, '12px'],
])

const fontColor = new Map([
  [1, '#172931'],
  [2, '#6A7980'],
  [3, '#999999'],
])

const navTabStep = new Map([
  [1, '0px'],
  [2, '20px'],
  [3, '50px'],
])

const fontWeight = new Map([
  [1, 600],
  [2, 400],
  [3, 400],
])

const TreeWrapper = styled.div`
  width: auto;
  height: auto;
  background: #fcf8f8;
`

const navCss = css`
  display: block;
  height: auto;
  width: 200px;
  user-select: none;
  font-size: ${({ rank }) => fontSize.get(rank) || '12px'};
  padding-left: ${({ rank }) => navTabStep.get(rank) || '80px'};
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  background: #f2f3f5;
  color: ${({ active }) => (active ? '#f2063f' : '#fff')};
  :hover {
    color: #f2063f;
  }
`

export const NavLink = styled(Link)`
  ${navCss};
  text-decoration: none;
  font-weight: ${({ rank }) => fontWeight.get(rank) || 400};
  font-size: ${({ rank }) => fontSize.get(rank) || '12px'};
  color: ${({ rank, active }) => (active ? '#f2063f' : fontColor.get(rank) || '#999999')};
  ${({ noneedborderleft, active }) =>
    !noneedborderleft &&
    css`
      border-left: ${active ? '3px' : '2px'} solid ${active ? '#f2063f' : '#e6e6e6'};
    `};
`

export const FoldDiv = styled.div`
  ${navCss};
  cursor: pointer;
  position: relative;
  height: 40px;
  line-height: 40px;
  color: ${({ rank }) => fontColor.get(rank) || '#999999'};
  font-size: ${({ rank }) => fontSize.get(rank) || '12px'};
  font-weight: ${({ rank }) => fontWeight.get(rank) || 400};
  > img {
    position: absolute;
    width: 12px;
    height: 12px;
    top: 16px;
    right: 10px;
  }
`

export const Section = styled.section`
  height: auto;
  display: ${({ fold }) => (fold ? 'none' : 'block')};
`

const RenderTree = (tree, rank = 1, slug = '', Location, isFoldList, setFoldList) => {
  const { setScrollTop } = useScrollTop('left-menu')
  const switchFolder = (rankIndex) => {
    const arr = JSON.parse(JSON.stringify(isFoldList))
    if (!isFoldList.includes(rankIndex)) {
      arr.push(rankIndex)
    } else {
      arr.splice(arr.indexOf(rankIndex), 1)
    }
    setFoldList(arr)
  }

  return (
    <>
      {tree.map((item, i) => {
        let contentNode, childrenNode
        const newSlug = `${slug}${item.slug ? '/' + item.slug : ''}`
        if (item.children?.length > 0) {
          childrenNode = RenderTree(
            item.children,
            rank + 1,
            newSlug,
            Location,
            isFoldList,
            setFoldList,
          )
        }
        return (
          <React.Fragment key={i}>
            {item.children.length > 0 ? (
              <FoldDiv rank={rank} onClick={() => switchFolder(`${item.slug}`)}>
                {item.title}
                {isFoldList.includes(`${item.slug}`) ? (
                  <img src={FoldIcon} alt='fold icon' />
                ) : (
                  <img src={ExpandIcon} alt='expand icon' />
                )}
              </FoldDiv>
            ) : (
              <NavLink
                rank={rank}
                to={`/${newSlug}/`}
                onClick={() => setScrollTop()}
                active={Location.pathname.includes(newSlug) ? 1 : 0}
                noneedborderleft={(rank & 1) === 1}
              >
                {item.title}
              </NavLink>
            )}
            {(contentNode || childrenNode) && (
              <Section fold={isFoldList.includes(`${item.slug}`)}>{childrenNode}</Section>
            )}
          </React.Fragment>
        )
      })}
    </>
  )
}

const NavTree = ({ tree, slug = '', Location }) => {
  const [isFoldList, setFoldList] = React.useState([])

  return (
    <TreeWrapper>{RenderTree(tree, 1, `${slug}`, Location, isFoldList, setFoldList)}</TreeWrapper>
  )
}

export default withLocation(NavTree)
